<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <md-card>
      <md-card-content md-gutter>
        <md-layout md-gutter>
          <md-layout md-flex="40" class="mobile-width pull-left pagetitleText ml-2 mb-2 mt-3">
            <h5><b>All Vehicles History List</b></h5>
          </md-layout>
        </md-layout>

        <md-card class="card">
          <md-card-content>

            <div class="box">
              <div class="box-header">
                <b-col md="12">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" v-model="vehicleHistoryfilter"
                        placeholder="Search Vehicle No. / Series / Approval / Complain" />
                      <b-input-group-append>
                        <b-button :disabled="!vehicleHistoryfilter" @click="vehicleHistoryfilter = ''">Clear</b-button>
                      </b-input-group-append>

                      <b-button :disabled="ExcelBtnName != 'Export As Excel' ? true : false" class="ml-2" size="sm"
                        variant="warning" @click="showVehicleHistory('Excel')">
                        {{ ExcelBtnName }}
                        <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner>
                      </b-button>

                      <h5 class="text-muted pull-right mt-2 ml-3">
                        <small v-if="isLoading == false">{{ totalRowsVehicleHistory }} History Entries</small>
                      </h5>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </div>


              <!-- Table Listing -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="vehicleHistoryList" :fields="vehicleHistoryFields"
                  :current-page="currentPage" :per-page="perPageVehicleHistory" :filter="vehicleHistoryfilter"
                  :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                  @filtered="onvehicleHistoryFiltered">

                  <template slot="vehicleId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPageVehicleHistory }}</span>
                  </template>

                  <template slot="vehicleNo" slot-scope="row1">
                    <span>{{row1.item.vehicleNo}}</span>
                  </template>

                  <template slot="serviceEstSeries" slot-scope="row2">
                    <span
                      @click="viewRequiredItemList(row2.item.itemForServiceEstId, row2.item.vehicleNo, row2.item.serviceEstDate )"
                      class="showMoreData">
                      {{row2.item.serviceEstSeries}}
                    </span>
                  </template>

                  <template slot="driverName" slot-scope="row3">
                    <span>{{row3.item.driverName}}</span>
                  </template>

                  <template slot="estimationDate" slot-scope="row4">
                    <span>{{row4.item.serviceEstDate}}</span>
                  </template>

                  <template slot="odometreReading" slot-scope="row5">
                    <span>{{row5.item.odometre_Reading}} <small v-if="row5.item.odometre_Reading != null"> km</small>
                    </span>
                  </template>

                  <template slot="driverComplain" slot-scope="row6">
                    <span>{{row6.item.driver_complain}}</span>
                  </template>

                  <template slot="approvedStatus" slot-scope="row7">
                    <span v-if="row7.item.approvedStatus == 'Approved'"
                      class="success">{{row7.item.approvedStatus}}</span>
                    <span v-else class="error">{{row7.item.approvedStatus}}</span>
                  </template>

                  <template slot="approvedBy" slot-scope="row8">
                    <span>{{row8.item.approvedBy}}</span>
                  </template>

                </b-table>
              </div>

              <!-- Pagination -->
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRowsVehicleHistory" :per-page="perPageVehicleHistory"
                    v-model="currentPage" class="my-0 pull-right" />
                </b-col>
              </b-row>

              <!-- Modal on SE Series Click -->
              <b-modal no-close-on-esc no-close-on-backdrop size="xl" ref="required-item-modal"
                title="Aproval / Rejection of Required Items" centered>

                <large class="pull-right mr-2 mb-2"> Vehicle No.: <b class="warning">{{ vehicleNo }}</b> </large>
                <large class="pull-right mr-2 mb-2"> <b>|</b> </large>
                <large class="pull-right mr-2 mb-2"> Estimation Date: <b class="warning">{{ serviceEstDate }}</b>
                </large>

                <div class="table-responsive tableMain">
                  <b-table show-empty stacked="md" :items="itemServiceDetails" :fields="itemServiceDetailsFields"
                    :current-page="currentPage" :per-page="perPageItemServiceDetails" :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc" :sort-direction="sortDirection">

                    <template slot="itemId" slot-scope="row0">
                      <span>{{row0.index + 1 + (currentPage - 1) * perPageItemServiceDetails }}</span>
                    </template>

                    <template slot="itemName" slot-scope="row1">
                      <span>{{row1.item.itemName}}</span>
                    </template>

                    <template slot="quantity" slot-scope="row2">
                      <span>{{row2.item.quantity}}</span>
                    </template>

                    <template slot="itemQuantity" slot-scope="row3">
                      <span>{{row3.item.itemQuantity}}</span>
                    </template>

                    <template slot="loginTime" slot-scope="row4">
                      <span>{{row4.item.loginTime}}</span>
                    </template>

                    <template slot="approvedStatus" slot-scope="row5">
                      <span v-if="row5.item.approvedStatus == 'Approved'"
                        class="success">{{row5.item.approvedStatus}}</span>
                      <span v-else class="error">{{row5.item.approvedStatus}}</span>
                    </template>

                    <template slot="approvedBy" slot-scope="row6">
                      <span>{{row6.item.approvedBy}}</span>
                    </template>

                  </b-table>
                </div>
              </b-modal>

            </div>

          </md-card-content>
        </md-card>

      </md-card-content>
    </md-card>

  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import { ModelListSelect } from "vue-search-select";

export default {
	beforeMount() {
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/vehicleServiceHistory/vehicleServiceHistory");
      this.showVehicleHistory('Normal');
    } else {
      this.$router.push({
          path: "/dashboard"
      });
    }
	},

	data() {
    return {
      vehicleHistoryList: [],
      vehicleID: "",
      vehicleHistoryfilter: null,
      perPageVehicleHistory: 5,
      totalRowsVehicleHistory: "",

      vehicleHistoryFields: [
        {
          key: "vehicleId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "vehicleNo", 
          label: "Vehicle No",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "serviceEstSeries", 
          label: "SE Series",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "driverName", 
          label: "Driver Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "estimationDate", 
          label: "Estimation Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "odometreReading", 
          label: "Meter Reading on Estimation",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "driverComplain", 
          label: "Driver Complain",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "approvedStatus", 
          label: "Approved Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "approvedBy", 
          label: "Approved By",
          sortable: true,
          sortDirection: "desc"
        },
      ],

      currentPage: 1,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",

      isLoading: false,

      itemServiceDetails: [],
      perPageItemServiceDetails: 8,

      itemServiceDetailsFields: [
        {
          key: "itemId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "itemName", 
          label: "Item Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "quantity", 
          label: "Available Quantity",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "itemQuantity", 
          label: "Required Quantity",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "loginTime", 
          label: "Creation Time",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "approvedStatus", 
          label: "Approved Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "approvedBy", 
          label: "Approved By",
          sortable: true,
          sortDirection: "desc"
        },
      ],

      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },

    };
	},

	mounted() {},
	filters: {
    moment(date) {
        return DateFormat(date)
    }
	},

	beforeDestroy() {},
	destroyed() {},

	components: {
    // Loading,
    CustomLoader,
    ModelListSelect,
	},

	computed: {
    sortOptions() {
      return this.fields
      .filter(f => f.sortable)
      .map(f => {
          return { text: f.label, value: f.key };
      });
    }
	},

	methods: {
		onvehicleHistoryFiltered(filteredItems){
      this.totalRowsVehicleHistory = filteredItems.length;
      this.currentPage = 1;
    },

    showVehicleHistory(type){

      // console.log("vehicle Hist ID", vehicleID);
      this.ExcelBtnName = "Downloading Please Wait...";

      if (type == "Normal") {
        this.doLoading();
        this.ExcelBtnName = "Export As Excel";
      }

      let payload = {
        view: "vehicleHistory",
        vehicleID: '',
        type: type
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewItemDetail.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
      .then(result => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {

            if (type == "Excel") {

              if (data.vehicleHistoryArray.length > 0) {
                this.vehicleHistoryList = data.vehicleHistoryArray;
              } 
              this.ExcelBtnName = "Export As Excel";
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;

            } else {

              if (data.vehicleHistoryArray.length > 0) {
                this.vehicleHistoryList = data.vehicleHistoryArray;
                this.totalRowsVehicleHistory = data.vehicleHistoryArray.length;
              } else {
                this.vehicleHistoryList = [];
                this.totalRowsVehicleHistory = "";
              }
            }
            this.doLoadingClose();
          }
        })
        .catch(error => {});
    },

    viewRequiredItemList(serviceItemIds, vehicleNo, serviceEstDate){
      // console.log("Service item Ids", serviceItemIds);
      this.showServiceEst(serviceItemIds);
      this.vehicleNo = vehicleNo;
      this.serviceEstDate = serviceEstDate;
      this.$refs["required-item-modal"].show();
    },

    showServiceEst(serviceid) {
      this.itemServiceDetails = [];

      let payload = {
        itemForServiceEstId: serviceid,
        serviceEstimationId: "",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewServiceItem.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemServiceDetails = data.itemArray;
            }
          }
        })
        .catch(error => {});
    },

    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
          this.isLoading = false;
      }, 500);
    },

	}
};
</script>

<style>
.md-button-color {
	background-color: #607d8d !important;
}
.error {
	color: red;
}
.success{
  color: green;
}
.warning{
  color:orangered;
}
.pagetitleText{
	color: #0e0052;
	text-transform: uppercase;
  font-size: 1.3rem !important;
}
@media (min-width:320px) and (max-width:767px) {
.mobile-width{min-width: 100%;display:inline-block;}
}
</style>




// WEBPACK FOOTER //
// vehicleServiceHistory.vue?8fe896c6